document.addEventListener("DOMContentLoaded", function () {
  const toc = document.querySelector(".js-toc");
  if (!toc) return;

  const toggleBtn = toc.querySelector(".toc__toggle");
  const tocBody = toc.querySelector(".toc__body");

  // アコーディオン開閉
  toggleBtn.addEventListener("click", function () {
    const isExpanded = toggleBtn.getAttribute("aria-expanded") === "true";
    toggleBtn.setAttribute("aria-expanded", String(!isExpanded));
    tocBody.style.display = isExpanded ? "none" : "block";
    toggleBtn.textContent = isExpanded ? "[開く]" : "[閉じる]";
  });

  // スムーススクロール（クリック時に毎回オフセット取得）
  toc.querySelectorAll("a[href^='#']").forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const header = document.querySelector("sticky-header");
      const offset = header ? header.offsetHeight : 0;

      const targetId = this.getAttribute("href");
      const targetEl = document.querySelector(targetId);

      if (targetEl) {
        const targetPosition =
          targetEl.getBoundingClientRect().top + window.pageYOffset - offset - 20;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      }
    });
  });
});
